import React, {useRef, useState} from 'react'
import Icons from '../../../../components/Icons'
import styled from 'styled-components'
import Avatar from '../../../../components/Avatar/Avatar'
import {Drop} from 'grommet/components/Drop'
import {_L, useLocaleState} from '../../../../context/LocaleContext'

const Row = styled.div`
  display: flex;
  margin: 10px 0 20px 0;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
`

const Name = styled.div`
  font-size: 15px;
  font-weight: bold;
  color: black;
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  padding-left: 18px;
`

const Title = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #171819;
`

const Workspace = styled(Title)`
  color: #52555B;
`

const Link = styled.div`
  width: 31px;
  height: 31px;
  cursor: pointer;
  box-sizing: border-box;
  -webkit-margin-end: 10px;
  margin-right: 10px;
`

const StyledDrop = styled(Drop)`
  margin-left: 6px;
`
const StyledOverlay = styled.div`
  color: #000000;
  font-weight: normal;
  padding: 8px 20px 8px 14px;
  font-size: 13px;
  line-height: 2em;
`

const StyledOverlayItem = styled.div`
  cursor: pointer;
`

const Employee = ({
  employee,
  requestSpaceChange,
  requestEmployeeLeave,
  isMoveEnabled
}) => {
  const [showOverlay, setShowOverlay] = useState(false)
  const localeState = useLocaleState()
  const {emId, url, emTitle, flId, rmId} = employee

  let employeeRef = useRef(null)

  return (
    <Row key={emId}>
      <Avatar url={url} large circle />
      <Name>
        {emId}
        <Title>{emTitle}</Title>
        <Workspace>
          {_L({key: 'Workspace', localeState})} {flId}-{rmId}
        </Workspace>
      </Name>
      {isMoveEnabled && (
        <Link onClick={() => setShowOverlay(true)} ref={employeeRef}>
          <Icons icon="MORE" />
        </Link>
      )}

      {employeeRef.current &&
        showOverlay && (
          <StyledDrop
            target={employeeRef.current}
            align={{left: 'right'}}
            onClickOutside={() => setShowOverlay(false)}
          >
            <StyledOverlay>
              <StyledOverlayItem onClick={() => requestSpaceChange(employee)}>
                {_L({key: 'Request Move', localeState})}
              </StyledOverlayItem>
              <StyledOverlayItem
                onClick={() => {
                  requestEmployeeLeave(employee)
                }}
              >
                {_L({key: 'Employee Leaving', localeState})}
              </StyledOverlayItem>
            </StyledOverlay>
          </StyledDrop>
        )}
    </Row>
  )
}

export default Employee
